var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7844_14331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.599 3.16663C10.859 3.16663 3.76562 10.26 3.76562 19C3.76562 27.74 10.859 34.8333 19.599 34.8333C28.339 34.8333 35.4323 27.74 35.4323 19C35.4323 10.26 28.339 3.16663 19.599 3.16663ZM19.599 31.6666C12.6165 31.6666 6.93229 25.9825 6.93229 19C6.93229 12.0175 12.6165 6.33329 19.599 6.33329C26.5815 6.33329 32.2656 12.0175 32.2656 19C32.2656 25.9825 26.5815 31.6666 19.599 31.6666ZM26.8665 12.0016L16.4323 22.4358L12.3315 18.3508L10.099 20.5833L16.4323 26.9166L29.099 14.25L26.8665 12.0016Z",
    fill: "#D8A353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7844_14331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.5815c953423d1a4556e08056a982433b.svg";
export { ForwardRef as ReactComponent };